import styled, { css, keyframes } from 'styled-components';
import { color } from '../../styles_js/variables';

const fadeDelay = keyframes`
  0%,
  39%,
  100% {
    opacity: 0.1;
  }

  40% {
    opacity: 1;
  }
`;

export const colorChooser = (type = 'default') => {
  return type === 'default' ? color.white : color[type];
};

const fadeAnimation = css`
  animation: ${fadeDelay} 1.2s infinite ease-in-out both;
`;

export const LoadingSpinnerSt = styled.div`
  position: relative;
  ${props => css`
    height: ${props.size}px;
    width: ${props.size}px;
  `};

  & > .sk-circle {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;

    &::before {
      display: block;
      background-color: ${props => colorChooser(props.type)};
      border-radius: ${p => `${p.itemSize / 2}px`};
      content: '';
      ${props => css`
        height: ${props.itemSize}px;
        width: ${props.itemSize}px;
      `};
      margin-right: auto;
      margin-left: auto;
      ${fadeAnimation};
    }
  }

  & > .sk-circle2 {
    transform: rotate(30deg);

    &::before {
      animation-delay: -1.1s;
    }
  }

  & > .sk-circle3 {
    transform: rotate(60deg);

    &::before {
      animation-delay: -1s;
    }
  }

  & > .sk-circle4 {
    transform: rotate(90deg);

    &::before {
      animation-delay: -0.9s;
    }
  }

  & > .sk-circle5 {
    transform: rotate(120deg);

    &::before {
      animation-delay: -0.8s;
    }
  }

  & > .sk-circle6 {
    transform: rotate(150deg);

    &::before {
      animation-delay: -0.7s;
    }
  }

  & > .sk-circle7 {
    transform: rotate(180deg);

    &::before {
      animation-delay: -0.6s;
    }
  }

  & > .sk-circle8 {
    transform: rotate(210deg);

    &::before {
      animation-delay: -0.5s;
    }
  }

  & > .sk-circle9 {
    transform: rotate(240deg);

    &::before {
      animation-delay: -0.4s;
    }
  }

  & > .sk-circle10 {
    transform: rotate(270deg);

    &::before {
      animation-delay: -0.3s;
    }
  }

  & > .sk-circle11 {
    transform: rotate(300deg);

    &::before {
      animation-delay: -0.2s;
    }
  }

  & > .sk-circle12 {
    transform: rotate(330deg);

    &::before {
      animation-delay: -0.1s;
    }
  }
`;
